__turbopack_context__.v({
  "className": "soehne_55ba58b1-module__EJlBKq__className",
});
